import React from 'react';
import { filter, map, uniq } from 'lodash';

import { selectErrors } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import { useSelector } from 'react-redux';
import { WarningIcon } from './Layout';

const ErrorComponent = ({ attr }: { attr: string }) => {
  const errors = useSelector(selectErrors);

  const ownErrors = uniq(filter(errors, error => error.attr === attr).map(error => error.detail)).sort();

  return (
    <>
      {ownErrors.length ? (
        <Tooltip data-aid="column-tooltip" message={<ErrorContext errors={ownErrors} />}>
          <WarningIcon errors={ownErrors} />
        </Tooltip>
      ) : null}
    </>
  );
};

const ErrorContext = ({ errors }: { errors: string[] }) => {
  return (
    <>
      {map(errors, error => (
        <div key={error}>{error}</div>
      ))}
    </>
  );
};

export default ErrorComponent;
